<template>
  <el-container class="main_container">
    <el-aside :class="isCollapse ? 'width64' : 'width220'">
      <template>
        <div class="div">
          <div class="survey_logo">
            <p v-if="isCollapse == false">
              <img src="https://download.hecoos.com/enlightv/2024-33/QSSSwTwjzRjCxjwehTiy.png" alt="" height="34">
              <span>澜景在线授权平台</span>
            </p>
          </div>
          <el-menu :default-active="defaultActive" :unique-opened="true" router :collapse="isCollapse">
            <template v-for="item in menuList">
              <el-menu-item :index="item.path" :key="item.id" v-if="!item.hasOwnProperty('child')">
                  <i :class="item.icon"></i> <span slot="title" class="blod">{{ item.name }}</span>
              </el-menu-item>
              <el-submenu :index="String(item.id)" :key="String(item.id)" v-if="item.hasOwnProperty('child')">
                <template slot="title">{{ item.name }}</template>
                <template v-for="sub in item.child">
                  <el-menu-item :index="sub.path" :key="sub.id" v-if="!sub.hasOwnProperty('subFunctions')">
                    {{ sub.name }}
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </template>
    </el-aside>
    <el-container>
      <el-header>
        <template>
          <div class="paas_header">
            <div class="menu_btn">
<!--              <span @click="toggleNav()" :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></span>-->
            </div>

            <div class="info_wrap">
              <div class="user_info">
                <img :src="userDetail.avatar ? userDetail.avatar: 'https://download.hecoos.com/enlightv/2024-33/HZHxfRWpzAKjx5Crb3AM.jpg'" alt="">
                <span class="user_name">{{userDetail.name}}</span>
              </div>

<!--              <el-popover  placement="bottom" popper-class="headerPopperClass"  width="230"  trigger="click" :visible-arrow="false" >-->
<!--                <div slot="reference" >-->
<!--                  <span class="template_color">切换账号</span>-->
<!--                </div>-->
<!--                <ul>-->
<!--                  <li>-->
<!--                    <div>澜景科技</div>-->
<!--                    <p>费方健</p>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <div>北京澜景科技有限公司</div>-->
<!--                    <p>费方健</p>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <div>钢铁侠科技有限公司</div>-->
<!--                    <p>费方健</p>-->
<!--                  </li>-->
<!--                </ul>-->
<!--                <div class="ta-r mt-16 add_other_accounts">-->
<!--                  <el-button type="text" @click="handleClickAddOtherAccounts">添加其他账号</el-button>-->
<!--                </div>-->

<!--              </el-popover>-->
              <span class="exit_btn" @click="out_login">退出</span>
            </div>
          </div>
        </template>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <el-dialog  title="添加账号"  :visible.sync="dialogVisible" :close-on-click-modal="false" width="450px"  :before-close="handleClickClose">
        <div class="ta-c">
          <el-button size="small" @click="handleClickJoinEnterprise">加入已有企业</el-button>
          <el-button size="small" @click="handleClickCreateEnterprise">创建新企业</el-button>
        </div>
    </el-dialog>

    <createEnterprise :createEnterpriseVisible.sync="createEnterpriseVisible" v-if="createEnterpriseVisible"  @success="createEnterSuccess()"/>
    <joinEnterprise :joinEnterpriseVisible.sync="joinEnterpriseVisible" v-if="joinEnterpriseVisible"  @success="joinEnterSuccess()"/>

  </el-container>


</template>
<script>

import { mapState } from 'vuex'
import {getMenuList} from "@/api/api";
import createEnterprise from './components/create_enterprise.vue'
import joinEnterprise from './components/join_enterprise.vue'
import {userDetail} from "../api/api";
export default {
  name: "layout",
  components: {
    createEnterprise,
    joinEnterprise,
  },
  computed: {
        ...mapState(['webUserInfo']),
  },
  data() {
    return {
      dialogVisible:false,
      joinEnterpriseVisible:false,
      createEnterpriseVisible:false,
      isCollapse: false,

      menuList: [
        {
          id: '001',
          name: '账户中心',
          child:[
            {
              id:'011',
              name:'个人信息',
              path:'personal'
            },
            // {
            //   id:'012',
            //   name:'企业信息',
            //   path:'information'
            // },
            {
              id:'013',
              name:'产品管理',
              path:'product_management'
            },
            // {
            //   id:'014',
            //   name:'用户管理',
            //   path:'user_management'
            // },
          ]
        },
      ],
      defaultActive: '',
      userDetail:{}
    }
  },
  created() {
    this.getUserDetail()
    this.defaultActive = this.$route.path.split('/')[1]
  },
  watch: {
    '$route.name': function (newVal, oldVal) {
      if (newVal) {

      }
    }
  },
  mounted() {

  },
  methods: {
    // 获取用户信息
    getUserDetail(){
      userDetail().then(res => {
        if (res.code === 200) {
          let {data} = res
          this.userDetail = data
        }
      }).catch(() => {
      })
    },
    // 添加其他企业
    handleClickAddOtherAccounts(){
      this.dialogVisible = true
    },
    handleClickClose(){
      this.dialogVisible = false
    },
    // 加入企业
    handleClickJoinEnterprise(){
      this.joinEnterpriseVisible = true
    },
    // 创建新企业
    handleClickCreateEnterprise(){
        this.createEnterpriseVisible = true
    },
    // 创建新企业确定回调
    createEnterSuccess(){

    },
    // 加入企业回调
    joinEnterSuccess(){

    },


    toggleNav() {
      this.isCollapse = !this.isCollapse
    },

    // 退出登录
    out_login(){
      this.$confirm('确定退出登录吗？', '提示', {
          type: 'error',
          closeOnClickModal: false,
          closeOnPressEscape: false,
      }).then(() => {
          // localStorage.removeItem('vuex')
          this.$store.dispatch('clearWebUserInfo')
          this.$router.replace({name:'login'});
      }).catch(() => {

      })
    },


  }
};
</script>
<style lang="scss" scoped>
.main_container {
  .el-header {
    background: #fff;
    padding: 0;
  }

  .el-aside {
    // height: calc(100vh - 60px);
    height:100vh;

    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    height: calc(100vh - 60px);
    background-color: #e9eef3;
    padding: 0;
  }
}

.width64 {
  width: 64px !important
}

.width220 {
  width: 220px !important
}

.survey_logo {
  border-bottom: 1px solid #f1f1f1;
  text-align: center;
}


.survey_logo p {
  margin-top: 0px;
  display: block;
  padding: 0 10px;
  font-size: 18px;
  line-height: 59px;
  letter-spacing: 2px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 0;
}
.survey_logo  p img{
  vertical-align: middle;
  margin-right: 5px;
}

::v-deep .el-menu {
  background: none !important;
  text-align: left;
  .el-submenu__title{
    color: rgba(25, 144, 255, 1);
  }
  .el-menu-item {
    height: 40px;
    line-height: 40px;
    &.is-active {
      background: rgba(25, 144, 255, 0.08);
      color: rgba(25, 144, 255, 1);
      position: relative;
      &:after{
        width: 2px;
        height: 40px;
        content: ' ';
        background:rgba(25, 144, 255, 1);
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}

.paas_header {
  height: 60px;
  display: flex;
  box-shadow: 0 1px 0 0 hsla(0, 0%, 93.3%, .5);
  border-bottom: 1px solid #f1f1f1;

  .menu_btn {
    display: inline-flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;

    span {
      color: #333;
      font-size: 30px;
      cursor: pointer;
    }
  }
  .info_wrap {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .user_info{
      display: flex;
      align-items: center;
      margin-right: 8px;
      cursor: pointer;
      img{
        width: 24px;
        height: 24px;
        margin-right: 8px;
        border-radius: 50%;
      }
      .user_name {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }
    }
    .template_color{
      font-size: 18px;
      line-height: 28px;
      cursor: pointer;
    }
    .exit_btn{
      margin: 0 35px 0 8px;
      font-size: 18px;
      color: rgba(240, 41, 41, 1);
      line-height: 28px;
      cursor: pointer;
    }

  }
}

.headerPopperClass{
  padding: 0 !important;
  ::v-deep.el-popover{
    padding: 0 !important;
  }
  ul{
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    li{
      padding: 3px 12px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      cursor: pointer;
      &.active{
        background: rgba(25, 144, 255, 1);
        div{
          color: #fff;
        }
        p{
          color: rgba(201, 229, 255, 1);
        }
      }
      &:hover{
        background: rgba(25, 144, 255, 1);
        div{
          color: #fff;
        }
        p{
          color: rgba(201, 229, 255, 1);
        }
      }
      div{
        line-height: 22px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
      }
      p{
        line-height: 20px;
        color: rgba(102, 102, 102, 1);
        font-size: 12px;
        margin-top: 2px;
      }

    }
  }
  .add_other_accounts{
    padding: 0 12px;
    box-sizing: border-box;
  }
}


</style>
